import URLParse from 'url-parse';

export const getPathnameFromURL = (url: string) => URLParse(url, true).pathname;
